var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { CardElement, useElements, useStripe } from '@stripe/react-stripe-js';
import { action } from 'mobx';
import { Observer } from 'mobx-react-lite';
import React from 'react';
import { ColorCodedState } from '../../@types/ui.controller.types';
import { PaymentEndpoints } from '../../endpoints/payment.endpoints';
import { useControllers } from '../../hooks/controller.hooks';
import { asyncGetRecaptchaToken, checkErrorForRecaptchaFailure } from '../../utils/loadRecaptcha.utils';
import { useProps, useStore } from '../../utils/mobx.utils';
import { autoPluralize } from '../../utils/string.utils';
import BaseButton from '../BaseButton/BaseButton';
import BaseGrid from '../BaseGrid/BaseGrid';
import BaseGridCell from '../BaseGrid/BaseGridCell';
import BaseInput from '../BaseInput/BaseInput';
import BaseSpacer from '../BaseSpacer/BaseSpacer';
import CurrencyRenderer from '../CurrencyRenderer/CurrencyRenderer';
import InfoBanner from '../InfoBanner/InfoBanner';
import PaymentCardForm from '../PaymentCardForm/PaymentCardForm';
import ShadedBlock from '../ShadedBlock/ShadedBlock';
import './OnceOffVisitorPaymentForm.scss';
var OnceOffVisitorPaymentForm = function (props) {
    var p = useProps(props);
    var _a = useControllers(), API = _a.API, UI = _a.UI;
    var s = useStore(function () { return ({
        form: {
            cardHolderName: '',
            email: '',
            message: '',
        },
        setupIntent: undefined,
        lastEvent: undefined,
        get error() {
            var _a;
            return (_a = s.lastEvent) === null || _a === void 0 ? void 0 : _a.error;
        },
        get completed() {
            var _a;
            return (_a = s.lastEvent) === null || _a === void 0 ? void 0 : _a.complete;
        },
        get canSubmit() {
            return Boolean(p.amount >= 1 &&
                s.completed &&
                !s.error &&
                !!s.form.cardHolderName &&
                !!s.form.email &&
                !s.messageTooLong);
        },
        hasSubmitted: false,
        get messageTooLong() {
            return s.form.message.length > 22;
        },
        recaptchaVerified: false,
    }); });
    var onCardChange = action(function (e) {
        s.lastEvent = e;
    });
    var stripe = useStripe();
    var elements = useElements();
    var pay = function () { return new Promise(function (resolve, reject) { return __awaiter(void 0, void 0, void 0, function () {
        var defaultConfirmationMessageRenderer, confirmationMessageRenderer, confirm, card, e_1, stripeCreateTokenResult, stripeToken, clientSecret, response, payload, url, e_2;
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    if (!p.amount || p.amount < 1) {
                        reject('The amount must be bigger than 1.');
                        return [2 /*return*/];
                    }
                    defaultConfirmationMessageRenderer = function (a) { return React.createElement(React.Fragment, null,
                        "Confirm payment of ",
                        React.createElement(CurrencyRenderer, { value: p.amount })); };
                    confirmationMessageRenderer = p.confirmationMessageRenderer || defaultConfirmationMessageRenderer;
                    return [4 /*yield*/, UI.DIALOG.present({
                            heading: function () { return confirmationMessageRenderer(p.amount); },
                            body: function () { return React.createElement("p", null, "You will receive a receipt in an confirmation email."); }
                        })];
                case 1:
                    confirm = _e.sent();
                    if (!confirm)
                        return [2 /*return*/];
                    _e.label = 2;
                case 2:
                    _e.trys.push([2, 11, , 12]);
                    if (!stripe) {
                        reject('Stripe is not initiated.');
                        return [2 /*return*/];
                    }
                    card = elements === null || elements === void 0 ? void 0 : elements.getElement(CardElement);
                    if (!card) {
                        reject('No Stripe form found in the application.');
                        return [2 /*return*/];
                    }
                    _e.label = 3;
                case 3:
                    _e.trys.push([3, 5, , 6]);
                    // recaptchaToken = await asyncGetRecaptchaToken('stripe_once_off_payment', UI);
                    return [4 /*yield*/, asyncGetRecaptchaToken('stripe_once_off_payment', UI, API)];
                case 4:
                    // recaptchaToken = await asyncGetRecaptchaToken('stripe_once_off_payment', UI);
                    _e.sent();
                    return [3 /*break*/, 6];
                case 5:
                    e_1 = _e.sent();
                    reject(e_1);
                    checkErrorForRecaptchaFailure(e_1);
                    UI.DIALOG.error({
                        heading: 'You have not passed the Recaptcha test. Please try again.',
                        error: e_1,
                    });
                    return [2 /*return*/];
                case 6: return [4 /*yield*/, (stripe === null || stripe === void 0 ? void 0 : stripe.createToken(card))];
                case 7:
                    stripeCreateTokenResult = _e.sent();
                    if (stripeCreateTokenResult.error) {
                        reject(stripeCreateTokenResult.error.message);
                        UI.DIALOG.error({
                            heading: 'Error processing your card.',
                            body: stripeCreateTokenResult.error.message,
                        });
                        return [2 /*return*/];
                    }
                    stripeToken = (_a = stripeCreateTokenResult.token) === null || _a === void 0 ? void 0 : _a.id;
                    if (!stripeToken) {
                        UI.DIALOG.error({
                            heading: 'Error processing your card.',
                        });
                        reject('Error processing your card.');
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, API.post(PaymentEndpoints.tokenise(), {
                            donationAmount: props.amount * 100,
                        })];
                case 8:
                    clientSecret = (_b = (_e.sent())) === null || _b === void 0 ? void 0 : _b.clientSecret;
                    if (!clientSecret) {
                        UI.DIALOG.error({
                            heading: 'Error connecting to payment service. Please try again later.',
                        });
                        reject('Error connecting to payment service. Please try again later.');
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, stripe.confirmCardPayment(clientSecret, {
                            receipt_email: s.form.email,
                            payment_method: {
                                card: card,
                                billing_details: {
                                    name: s.form.cardHolderName,
                                    email: s.form.email,
                                }
                            }
                        })];
                case 9:
                    response = _e.sent();
                    if (response.error) {
                        UI.DIALOG.error({
                            heading: response.error.message,
                        });
                        reject(response.error.message);
                        return [2 /*return*/];
                    }
                    payload = {
                        amount: props.amount,
                        cardHolderName: s.form.cardHolderName,
                        email: s.form.email,
                        message: s.form.message,
                    };
                    url = PaymentEndpoints.reportSingleChargeSuccess();
                    return [4 /*yield*/, API.postRaw(url, payload)];
                case 10:
                    _e.sent();
                    s.hasSubmitted = true;
                    (_c = p.onSuccess) === null || _c === void 0 ? void 0 : _c.call(p);
                    resolve(true);
                    return [3 /*break*/, 12];
                case 11:
                    e_2 = _e.sent();
                    reject(e_2);
                    (_d = p.onError) === null || _d === void 0 ? void 0 : _d.call(p, e_2);
                    return [3 /*break*/, 12];
                case 12: return [2 /*return*/];
            }
        });
    }); }); };
    var defaultButtonLabelRenderer = function (a) { return React.createElement(React.Fragment, null,
        "Pay ",
        React.createElement(CurrencyRenderer, { value: p.amount })); };
    var buttonLabelRenderer = p.buttonLabelRenderer || defaultButtonLabelRenderer;
    return React.createElement(Observer, { children: function () { return (React.createElement("div", { className: "OnceOffVisitorPaymentForm" },
            React.createElement(ShadedBlock, null,
                React.createElement(BaseGrid, { gap: "1em", columns: 2 },
                    React.createElement(BaseInput, { label: "Card Holder Name", form: s.form, field: "cardHolderName", autoComplete: "full-name", required: true }),
                    React.createElement(BaseInput, { label: "Email", form: s.form, field: "email", autoComplete: "email", type: "email", required: true }),
                    React.createElement(BaseGridCell, { columns: "all" },
                        React.createElement(PaymentCardForm, { onChange: onCardChange })),
                    React.createElement(BaseGridCell, { columns: "all" },
                        React.createElement(BaseInput, { label: "Add a message", form: s.form, field: "message", type: "textarea", optional: true, infoAfterInputField: "Maximum 22 characters; must contain at least one alphabetical letter." }),
                        s.messageTooLong && React.createElement(InfoBanner, { colorCodedState: ColorCodedState.alert },
                            React.createElement("p", null,
                                "The message is limited to 22 characters at most. You are ",
                                React.createElement("strong", null, autoPluralize(s.form.message.length - 22, 'character')),
                                " over the limit."))))),
            React.createElement(BaseSpacer, null),
            React.createElement(BaseButton, { onClick: pay, size: "lg", fullWidth: true, disabled: !s.canSubmit }, buttonLabelRenderer(p.amount)))); } });
};
export default OnceOffVisitorPaymentForm;
